<template>
  <div>
    <div v-if="isLoading" class="text-center p-4">
      Loading quiz...
    </div>
    <div v-else-if="loadError" class="alert alert-danger" role="alert">
      {{ loadError }}
    </div>
    <QuestionQuizFullPageSplitScreen
      v-else-if="isSplitView"
      ref="quizView"
    />
    <QuestionQuizFullPageFullScreen
      v-else-if="!isSplitView"
      ref="quizView"
    />
  </div>
</template>

<script>
import { Apps } from "../../../FackApi/api/apps.js"
import QuestionQuizFullPageFullScreen from "./QuestionQuizFullPageFullScreen.vue"
import QuestionQuizFullPageSplitScreen from "./QuestionQuizFullPageSplitScreen.vue"
import { socialvue } from "../../../config/pluginInit.js"

export default {
  name: "QuestionQuizFullPageV1",
  components: {
    QuestionQuizFullPageFullScreen,
    QuestionQuizFullPageSplitScreen
  },
  mounted () {
    socialvue.index()
    this.loadQuizViewType()
  },
  data () {
    return {
      isLoading: true,
      isSplitView: true,
      loadError: null
    }
  },
  computed: {
    appId () {
      return this.$route.params.appId
    }
  },
  watch: {
    appId: {
      handler () {
        this.loadQuizViewType()
      },
      immediate: true
    }
  },
  methods: {
    async loadQuizViewType () {
      this.isLoading = true
      this.loadError = null

      const response = await Apps.appView(this, this.appId)
      const appDetail = response && response.resp_data && response.resp_data.data
      if (!response || !response.resp_status || !appDetail) {
        this.loadError = (response && response.resp_msg) || "Unable to load the quiz layout."
        this.isLoading = false
        return
      }
      // is_split_view: 1 = Split Screen (default), 0 = Full Screen
      this.isSplitView = appDetail.is_split_view === true || appDetail.is_split_view === 1 || appDetail.is_split_view === "1"
      this.isLoading = false
    }
  },
  beforeRouteLeave (to, from, next) {
    const quizView = this.$refs.quizView
    if (!quizView || !quizView.examDetail || quizView.exitingQuiz) {
      return next()
    }

    const answer = window.confirm("Navigating away from an active assessment is restricted. Please complete your test before exiting.. If you exit, you shall forefeit this attempt. Do you want to exit ?")
    if (answer) {
      next()
    }
    else {
      next(false)
    }
  }
}
</script>
